import './Incidents.css'

// Shared segmented sub-nav used inside incident detail tabs (Related, Dashcam).
// items: [{ id, label, icon, count }] -- `icon` is a font-awesome class, `count`
// is optional (omit/null to render a label-only segment, e.g. the dashcam tab).
function IncidentSubNav({ items, activeId, onSelect }) {
    return (
        <div className="incident-subnav">
            {items.map((item) => {
                const isActive = item.id === activeId
                return (
                    <button
                        key={item.id}
                        type="button"
                        className={`incident-subnav__btn ${isActive ? "is-active" : ""}`}
                        onClick={() => onSelect(item.id)}
                    >
                        {item.icon && <i className={`fa ${item.icon}`} aria-hidden="true" />}
                        <span className="incident-subnav__label">{item.label}</span>
                        {item.count != null && <span className="incident-subnav__count">{item.count}</span>}
                    </button>
                )
            })}
        </div>
    )
}

export default IncidentSubNav
